export { default } from './info-list';
export type { IInfoListItem } from './info-list';
